import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LckrComponent } from './lckr.component';
import { ListKeywordDetailsComponent } from './list-keyword-details/list-keyword-details.component';
import { ListComponent } from './list/list.component';
import { KeywordFinderComponent } from '../keyword-finder/keyword-finder/keyword-finder.component';
import { Dashboard2Component } from './dashboard2/dashboard2.component';

const routes: Routes = [
  {
    path: '', component: LckrComponent, children: [
      // { path: '', redirectTo: 'keyword_finder', pathMatch: 'full' },
      // { path: 'keyword_finder', component: KeywordFinderComponent,title: 'Low Competition Kw Research' },
      { path: 'dashboard', component: DashboardComponent,title: 'Low Competition Kw Research | Strell.io' },
      { path: 'dashboard/:id', component: DashboardComponent,title: 'Low Competition Kw Research | Strell.io'
      // resolve:{
      //   // cres:ResolverService
      // }
     },
     { path: 'dashboard2/:id', component: Dashboard2Component,title: 'Low Competition Kw Research | Strell.io'},
      { path: 'list', component: ListComponent },
      { path: 'list-keyword-details', component: ListKeywordDetailsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[]
})
export class LckrRoutingModule { }
